export default __webpack_public_path__ + "static/media/sankey_when_relationship.1bb595fd.csv";